import { AppStrings } from "./constants/AppStrings";

/**
 * Resolve a sidebar `labelKey` (an AppStrings key) to display copy.
 *
 * WHY this exists: `label: AppStrings.X` in the `*_OPTIONS` arrays of
 * src/utils/Constants.js is evaluated when the module graph loads — before
 * `loadAppStringsForLanguage()` in src/index.js has replaced the bundled
 * English defaults — so every module-level label capture is frozen English
 * in all locales (`setAppString` reassigns the exported binding; it cannot
 * retroactively fix values copied out of it). Sidebar entries therefore
 * carry a `labelKey` and the display string is resolved here at render
 * time. Keep this the ONLY resolution point for sidebar labels.
 *
 * Falls back to the key itself so a missing/renamed key is visible in the
 * UI instead of rendering an empty entry.
 */
export const resolveSidebarLabel = (labelKey) =>
  AppStrings[labelKey] ?? labelKey;
